import { atom } from 'jotai';
import { atomWithReset, RESET } from 'jotai/utils';
import { Step } from '../components/StepsList/StepsList';

export const currentStepAtom = atomWithReset<number>(0);
export const stepsAtom = atomWithReset<Step[]>([]);
export const isCompleteAtom = atomWithReset<boolean>(false);
export const backgroundAtom = atomWithReset<string | undefined>(undefined);

export const incrementStepAtom = atom(null, (get, set) => {
  const steps = get(stepsAtom);
  const currentStep = get(currentStepAtom);
  const nextStep = currentStep + 1;
  const isComplete = nextStep >= steps.length;

  set(currentStepAtom, isComplete ? steps.length : nextStep);
  set(isCompleteAtom, isComplete);
});

export const initializeProgressBarAtom = atom(
  null,
  (get, set, payload: { steps: Step[]; background?: string }) => {
    set(stepsAtom, payload.steps);
    set(backgroundAtom, payload.background);
    set(currentStepAtom, 0);
    set(isCompleteAtom, false);
  },
);

export const resetProgressBarAtom = atom(null, (get, set) => {
  set(currentStepAtom, RESET);
  set(stepsAtom, RESET);
  set(isCompleteAtom, RESET);
  set(backgroundAtom, RESET);
});
